import { Component, OnInit, Input } from '@angular/core';
import { ReportMode } from '@enums/report-mode.enum';
import { ReportCustom } from '@classes/report/report-custom';
import { ReportDataType } from '@enums/report-data-type.enum';

@Component({
    selector: 'app-report-custom',
    templateUrl: './report-custom.component.html',
    styleUrls: ['./report-custom.component.scss']
})
export class ReportCustomComponent implements OnInit {
    @Input() report: ReportCustom;
    @Input() selMode: ReportMode;

    dataType = ReportDataType;
    reportMode = ReportMode;

    constructor() { }

    ngOnInit() {
    }

}
